import { render, staticRenderFns } from "./SideArrowSvg.vue?vue&type=template&id=6b76046c"
import script from "./SideArrowSvg.vue?vue&type=script&lang=js"
export * from "./SideArrowSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports